module.exports = "/packs/shares-4929970-a6cfedc2f4beb9d11d54b9c4277d15a7.png";